var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('div',{staticClass:"header-wrap"},[_c('default-header')],1),_c('div',{staticClass:"sidebar-wrap"},[_vm._l((_vm.sidebarRouterList),function(item){return [(
          (_vm.$route.meta.sidebarLayer &&
            _vm.$route.meta.sidebarLayer === item.type) ||
            (!_vm.$route.meta.sidebarLayer &&
              item.type === _vm.$projectConfig.sidebarLayer.otherLayer)
        )?_c('default-sidebar',{key:item.type,attrs:{"sidebar-router":item.routerList ? item.routerList : []}}):_vm._e()]})],2),_c('div',{staticClass:"page-content-wrap"},[_c('transition',{attrs:{"name":"down","mode":"out-in"}},[_c('router-view',{key:_vm.$route.meta.category})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }